import type { Kurs } from "./general";

export const KursyDoradcaList: Array<Kurs> = [
	{
		slug: "kurs_dp_ustn_pisem_3",
		title: "Doradca Podatkowy Egzamin ustny i pisemny – 3 edycja",
		description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
		level: null,
		category: "doradca-podatkowy",
	},
	// {
	// 	slug: "kurs_dp_ustn_2",
	// 	title: "Doradca Podatkowy Egzamin ustny - 2 edycja",
	// 	description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.",
	// 	level: null,
	// },
	{
		slug: "kurs_dp_ustn_3",
		title: "Doradca Podatkowy Egzamin ustny - 3 edycja",
		description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum.",
		level: null,
		category: "doradca-podatkowy",
	},
	// {
	// 	slug: "kurs_dp_pisem_2",
	// 	title: "Doradca Podatkowy Egzamin pisemny – 2 edycja",
	// 	description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia.",
	// 	level: null,
	// },
	// {
	// 	slug: "kurs_dp_ustn_pisem_2",
	// 	title: "Doradca Podatkowy Egzamin ustny i pisemny – 2 edycja",
	// 	description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.",
	// 	level: null,
	// },
	{
		slug: "kurs_dp_ustn_pisem_3_bez_materialow",
		title: "Doradca Podatkowy Egzamin ustny i pisemny – 3 edycja (bez materiałów)",
		description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis.",
		level: null,
		category: "doradca-podatkowy",
	},
	{
		slug: "kurs_dp_testy",
		title: "Doradca Podatkowy Egzamin na doradcę podatkowego - testy",
		description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit.",
		level: null,
		category: "doradca-podatkowy",
	},
];
